import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_LICENSES = 'GET_LICENSES';

export const actions = createSagaActionTypes('LICENSES', [GET_LICENSES]);
